import { ModelParameter } from "../mlmodel/mlModel-parameters.model";

export class ConfigureNewModel {
  modelName: string;
  modelType: string;
  modelUrl: string;
  modelVersion: string;
  authId: number;
  baseModelId: number;
  clientKeyName: string;
  clientKeyValue: string;
  scopeKeyName: string;
  scopeKeyValue: string;
  secretKeyName: string;
  secretKeyValue: string;
  subscriptionKeyName: string;
  subscriptionKeyValue: string;
  inputParameters: ModelParameter[];
  outputParameters: ModelParameter[]
}
